import { es, enUS } from 'date-fns/locale';

export default {
  en: enUS,
  es,
};
